import styled from 'styled-components'
import { MarkdownToReact } from '../../components/markdown/MardownToReact'
import { theme } from '../../theme/theme'

export const PolicyDocumentBody = ({ markdown }: { markdown: string }) => (
  <PolicyText>
    <MarkdownToReact markdown={markdown} gfm />
  </PolicyText>
)

const PolicyText = styled.div`
  h1 {
    margin-top: ${theme.spacing.small}px;
    font-size: ${theme.fontSize.xlarge}px;
    line-height: 38px;
  }

  h2 {
    margin-top: ${theme.spacing.large}px;
    font-size: ${theme.fontSize.large}px;
    line-height: 30px;
    color: ${theme.color.plum};
  }

  h3 {
    font-size: ${theme.fontSize.medium}px;
    line-height: 28px;
  }

  p,
  li {
    font-size: ${theme.fontSize.default}px;
    line-height: 24px;
  }

  p {
    margin-bottom: ${theme.spacing.small}px;
  }

  ul {
    margin-bottom: ${theme.spacing.small}px;
  }

  li {
    margin: ${theme.spacing.tiny}px 0;
  }
`
